import { css } from "@emotion/react";
import { colors, VStack } from "goi_common";
import { useMemo } from "react";

function FacilityFeeSection({ hospice }: { hospice: any }) {
  return (
    <>
      <FacilityTable title="병실 현황" th="병실 수" items={hospice.rooms} />
      <FacilityTable
        title="시설 현황"
        th="시설 수"
        items={hospice.facilities}
      />
    </>
  );
}

export default FacilityFeeSection;

function FacilityTable({
  title,
  th,
  items,
}: {
  items: Array<any>;
  th: string;
  title: string;
}) {
  const itemsNumberSum = useMemo(() => {
    const priceArr = items.map((res: { number: number }) => res.number);
    return priceArr.reduce((a: number, b: number) => a + b);
  }, []);

  return (
    <VStack margin="32px 20px 0px" gap="20px">
      <div className="subtitle_14_b">{title}</div>
      <table
        css={css`
          width: 100%;
        `}
      >
        <thead
          css={css`
            background: ${colors.warmGray150};
          `}
          className="caption_12_b gray900"
        >
          <tr>
            <th
              css={css`
                padding: 6px;
                width: 30%;
              `}
            >
              분류
            </th>
            <th
              css={css`
                padding: 6px;
                width: 30%;
              `}
            >
              {th}
            </th>
          </tr>
        </thead>
        <tbody className="caption1 gray900">
          {items && items.length > 0 ? (
            <>
              {items.map((item: any) => {
                return (
                  <tr
                    key={item.name}
                    css={css`
                      text-align: center;
                      border-bottom: 1px solid ${colors.gray100};
                    `}
                  >
                    <td
                      css={css`
                        padding: 10px;
                      `}
                    >
                      {item.name}
                    </td>
                    <td
                      css={css`
                        padding: 10px;
                      `}
                    >
                      {item.number}
                    </td>
                  </tr>
                );
              })}
              {title === "병실 현황" && (
                <tr
                  css={css`
                    text-align: center;
                    border-bottom: 1px solid ${colors.gray100};
                  `}
                >
                  <td
                    css={css`
                      padding: 10px;
                    `}
                  >
                    <b>병상 총계</b>
                  </td>
                  <td
                    css={css`
                      padding: 10px;
                    `}
                  >
                    <b>{itemsNumberSum}</b>
                  </td>
                </tr>
              )}
            </>
          ) : (
            <td
              colSpan={3}
              css={css`
                width: 100%;
                height: 180px;
                background: ${colors.warmGray50};
                vertical-align: center;
              `}
            >
              <VStack
                width="100%"
                height="100%"
                alignItems="center"
                justifyContent="center"
                className="caption1"
              >
                가격 정보를 준비중입니다.
              </VStack>
            </td>
          )}
        </tbody>
      </table>
    </VStack>
  );
}
